export default {
  loading: false,
  scaleSummaryLoading: false
}
